import script from "./Articles.vue?vue&type=script&setup=true&lang=ts"
export * from "./Articles.vue?vue&type=script&setup=true&lang=ts"

import "./Articles.vue?vue&type=style&index=0&id=55708a0b&lang=scss"

const __exports__ = script;

export default __exports__